export const DATA_LIVELLO1: string = 'sport';
export const DATA_PAGETEMPLATE: string = 'livematch';

export interface ICustomTrackingObject {
  quartoLivello?: string;
  intcmp?: string;
}

export const getDigitalData = (analytics: string, digitalData: any, customObject: ICustomTrackingObject): any => {
  const arrayAnalytics: string[] = analytics.split(':');
  const pageInfo: object = {
    pageName: analytics,
    livello1: arrayAnalytics[0] ?? DATA_LIVELLO1,
    secondolivello: arrayAnalytics.length > 1 ? `${DATA_LIVELLO1}-${arrayAnalytics[1]}` : '',
    terzolivello: arrayAnalytics.length > 2 ? `${DATA_LIVELLO1}-${arrayAnalytics[2]}` : '',
    quartolivello:
      arrayAnalytics.length > 3 ? `${DATA_LIVELLO1}-${customObject?.quartoLivello || arrayAnalytics[3]}` : '',
    pagetemplate: DATA_PAGETEMPLATE,
    intcmp: customObject.intcmp,
  };

  const digitalDataUpdate = {
    ...digitalData,
    page: {
      ...(digitalData?.page ?? {}),
      pageInfo: {
        ...(digitalData?.page?.pageInfo ?? {}),
        ...pageInfo,
      },
    },
  };

  return digitalDataUpdate;
};

export const setDigitalData = (analytics: string, customObject: ICustomTrackingObject): void => {
  const digitalData: any = (window as any).digitalData || {
    page: {
      pageInfo: {},
    },
  };

  // SPLITTED for TESTING
  (window as any).digitalData = getDigitalData(analytics, digitalData, customObject);
};
